/** Общие помощники про устройство: запуск с экрана «Домой», платформа, установка PWA. */

export function isStandalone(): boolean {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

export function detectPlatform(): "ios" | "android" | "desktop" {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";
  if (/Macintosh|Mac OS X/.test(ua) && navigator.maxTouchPoints > 1) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
}

/** iPhone/iPad в настоящем Safari (не Chrome/Firefox/Edge на iOS). */
export function isIosSafari(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return detectPlatform() === "ios" && /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
}

export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
};

// Событие beforeinstallprompt приходит один раз и рано — запоминаем его глобально.
let deferredPrompt: BeforeInstallPromptEvent | null = null;
const listeners = new Set<() => void>();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e as BeforeInstallPromptEvent;
    listeners.forEach((l) => l());
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((l) => l());
  });
}

export function getDeferredInstallPrompt(): BeforeInstallPromptEvent | null {
  return deferredPrompt;
}

export function subscribeInstallPrompt(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export type InAppBrowser = "instagram" | "facebook" | "tiktok" | "snapchat";

/** Встроенный браузер соцсети по userAgent: там нельзя установить приложение и включить пуши. */
export function detectInAppBrowser(ua?: string): InAppBrowser | null {
  const s = ua ?? (typeof navigator === "undefined" ? "" : navigator.userAgent);
  if (!s) return null;
  if (/Instagram/i.test(s)) return "instagram";
  if (/FBAN|FBAV|FB_IAB|FBIOS|FB4A/.test(s)) return "facebook";
  if (/TikTok|musical_ly|Bytedance|BytedanceWebview/i.test(s)) return "tiktok";
  if (/Snapchat/i.test(s)) return "snapchat";
  return null;
}
